var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Google OAuth Login")]),(_vm.user)?_c('div',[_c('p',[_vm._v("Welcome, "+_vm._s(_vm.user.name)+"!")]),_c('img',{attrs:{"src":_vm.user.picture,"alt":"User Picture"}}),_c('p',[_vm._v("Email: "+_vm._s(_vm.user.email))])]):_c('div',{attrs:{"id":"g_id_onload"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }